import { render, staticRenderFns } from "./UserPreferencesForm.vue?vue&type=template&id=49e9de11&"
import script from "./UserPreferencesForm.vue?vue&type=script&lang=js&"
export * from "./UserPreferencesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports